import {useCallback} from 'react';

import {MAX_NUMBER_VALUE} from 'src/constants';
import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getAccountMcpLimits, saveAccountMcpLimits} from 'src/openapi/admin/apis/AccountMcpLimitsApi';
import {useAppDispatch} from 'src/store/hooks';

import type {Limit} from 'src/openapi/admin/models/Limit';

type Props = {
    accountId: number,
};

export const useAccountMcpLimits = ({accountId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(
        async (signal: AbortSignal) => {
            const result = await apiDispatch(
                getAccountMcpLimits({accountId}, {signal}),
            );
            if (result.payload.success) {
                return {
                    ...result,
                    payload: {
                        ...result.payload,
                        data: result.payload.data.filter(
                            (l: Limit) => l.value
                                !== MAX_NUMBER_VALUE,
                        ),
                    },
                };
            }
            return result;
        },
        [accountId, apiDispatch],
    );

    const saveDispatchAction = useCallback((limit: Limit[], signal: AbortSignal) => apiDispatch(
        saveAccountMcpLimits({accountId, limit}, {signal}),
    ), [accountId, apiDispatch]);

    return useCommonDataHook({
        initValue: [] as Limit[],
        getDispatchAction,
        saveDispatchAction,
    });
};
